export const STRIPE_PUBLISHABLE_KEY =
  'pk_live_51PJi1tLbSnnwi7BMIGANjjg4TIuxbddFGi1TQYY2Ss82dmsYlhHfY8uh9uEizveBg5EfU0qv4ip4TyseTJU9Ofgz00BgdZiQF6';

export const APP_API_ENDPOINT =
  'https://lsy7o0n6h8.execute-api.us-west-2.amazonaws.com/prod';

export const AWS_REGION = 'us-west-2';
